import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { GiGolfFlag } from 'react-icons/gi';
import { MdOutlineFilterAltOff, MdOutlineGolfCourse } from 'react-icons/md';
import QdtComponent from '../../components/QdtComponent';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';
import Footer from '../../components/Footer';
import FiltersSelection from '../../components/FiltersSelection';
import { GoSearch } from 'react-icons/go';


export default function HoleDashboard() {
	const {goToTop, clearAllSelections} = useApp()

	document.title = '2024 The Parseghian Classic - Hole by Hole'
	
	useEffect(() => {
    goToTop()
  }, [goToTop])

  return (
		<motion.div variants={fadeIn} initial="hidden" animate="show">
			<section className="bg-overlay golf-field-bg-img bg-img-property pt-2">
					<div className="container pb-5">
						<FiltersSelection />
						{/* <div className="row mb-3 mt-5">
							<div className="col-lg-6 col-md-12 border-end border-light">
								<p className="text-start text-light fs-6">Player</p> 
								<QdtComponent
									type='QdtSearch'
									props={{
										cols: ['Golfer'],
										placeholder: 'Golfer Search...',
									}}
								/>					
							</div>
							<div className="col-lg-6 col-md-12 row">
								<div className="col-lg-6 col-md-12">
									<p className="text-start text-light fs-6 w-100">Round</p> 
										<QdtComponent
											type="QdtFilter"
											props={{
												cols: ['Round'],
												placeholder: 'Round',
												expandedHorizontal: true,
												autoSortByState: 0
											}}
										/>
								</div>
								<div className="col-lg-6 col-md-12">
								<p className="text-start text-light fs-6">Side</p> 
										<QdtComponent
											type="QdtFilter"
											props={{
												cols: ['Side'],
												placeholder: 'Side',
												expandedHorizontal: true,
												autoSortByState: 0
											}}
										/>	
								</div>
							</div>
						</div> 
						<div className="row mb-3">
							<p className="text-lg-center text-sm-start text-light">Hole</p> 
								<QdtComponent
									type="QdtFilter"
									props={{
										cols: ['Hole'],
										placeholder: 'Hole',
										expandedHorizontal: true,
										autoSortByState: 0
									}}
								/>		
						</div>  */}

					<section className="mt-lg-3">
						<div className="container mb-3" >
							<div className="row" >
								<div className="card border-theme" style={{background: 'rgba(255, 255, 255, .85)', borderRadius: '15px' }}>
									<div className="row card-header bg-sm-transparent bg-theme" style={{ borderRadius: '15px 15px 0 0' }}>
										<div className='col-5'>
												<div className="fs-sm-2 fs-4 text-theme-yellow d-flex align-items-center">
														<MdOutlineGolfCourse size={24} className="me-3 "/>
														Hole by Hole Dashboard
													</div>
										</div>
										<div className="col-7 text-light text-end justify-content-end d-flex gap-2">
											<a className='btn btn-sm text-theme btn-outline-light' data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
												<GoSearch size={20}/>
											</a>
											<button onClick={() => clearAllSelections()} className="btn btn-sm text-theme btn-outline-light">
												<MdOutlineFilterAltOff size={20}/>
											</button>
											{/* <button onClick={() => clearAllSelections()} className="btn btn-theme text-theme">Clear Selections</button> */}
										</div>
									</div>
									<div className="card-body">
										<div className="row row-cols-lg-2 row-cols-sm-1">
											<div className="col-lg-7 col-md-12 mb-3">
												{/* <div className="rounded-3 border-theme-yellow shadow-lg" >
													<QdtComponent
														type="QdtViz"
														props={{
															id: 'vqYupcu',
															height: '550px'
														}}
													/>
												</div> */}
												<div className="rounded-3 border-theme-yellow shadow-lg" >
													<QdtComponent
														type="QdtViz"
														props={{
															id: 'vqYupcu',
															height: '275px'
														}}
													/>
												</div> 
												<div className="rounded-3 border-theme-yellow shadow-lg mt-2" >
													<QdtComponent
														type="QdtViz"
														props={{
															id: 'nNKwWc',
															height: '275px'
														}}
													/>
												</div> 
											</div>
											<div className="col-lg-5 col-md-12">
												<div className="rounded-2 border-theme-yellow shadow-lg">
													<QdtComponent
														type="QdtViz"
														props={{
															id: 'jyJjn',
															height: '558px'
														}}
													/>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col-lg-12">
												<div className="rounded-2 border-theme-yellow shadow-lg">
													<QdtComponent
														type="QdtViz"
														props={{
															id: 'vxCmeR',
															height: '550px'
														}}
													/>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer bg-transparent">
									<div className="row">
										<div className="col">
											<GiGolfFlag color="green" size={32}/>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>

				<Footer />
			</section>
		</motion.div>
  )
}